module.exports = {
  PACK1: 'PACK 1',
  PACK2: 'PACK 2',
  PACK3: 'PACK 3',
};
